import { Switch, Route, Redirect } from 'react-router-dom';
import Welcome from '../pages/Welcome';
import Home from '../pages/Home';
import Redes from '../pages/Redes';
import Equipments from '../pages/Equipments';
import Equipment from '../pages/Equipment';
import Search from '../pages/Search';
import Entities from '../pages/Entities';
import Phones from '../pages/Phones';
import SearchResult from '../pages/SearchResult';
import NotFound from '../pages/NotFound';
import Legislation from '../pages/Legislation';
import ServiceType from '../pages/ServiceType';

export function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <Welcome/>
      </Route>
      <Route exact path="/home">
        <Home/>
      </Route>
      <Route exact path="/redes">
        <Redes/>
      </Route>

      <Route exact path="/redes/:redeId">
        <ServiceType/>
      </Route>
      <Route exact path="/redes/:redeId/:serviceId">
        <Equipments/>
      </Route>
      <Route exact path="/redes/:redeId/:serviceId/:equipmentId">
        <Equipment/>
      </Route>

      <Route exact path="/legislacao">
        <Legislation/>
      </Route>

      <Route exact path="/entidades">
        <Entities/>
      </Route>

      <Route exact path="/telefones">
        <Phones/>
      </Route>

      <Route exact path="/pesquisar">
        <Search/>
      </Route>

      <Route exact path="/result">
        <SearchResult/>
      </Route>

      <Route path="/404">
        <NotFound/>
      </Route>
      
      <Redirect to="/404"/>

    </Switch>
  );
}